import TomSelect from "tom-select";
console.log("Load: TomSelect");

function initTomSelect() {
  document.querySelectorAll("select").forEach((el) => {
    if (el.dataset.tomSelectInitialized) return;
    el.dataset.tomSelectInitialized = "true";

    const url = el.dataset.selectUrl;

    const options = {
      maxOptions: null,
      closeAfterSelect: true,
      dropdownParent: 'body',
      create: false,
      persist: false,
      maxItems: 1,
      allowEmptyOption: false,
      onItemAdd: function() {
        this.control_input.blur();
        this.close();
      },
      onDropdownOpen: function() {
        this.clear(); // Clear the current selection when opening
        this.control_input.focus();
      },
      onDropdownClose: function() {
        if (this.items.length === 0 && this.settings.placeholder) {
          // If nothing selected, you might want to restore previous value
          // Or leave empty - depends on your UX preference
        }
      }
    };

    //  Only add AJAX loading if a URL is provided
    if (url) {
      options.valueField = "id";
      options.labelField = "label";
      options.searchField = "label";
      options.preload = false;
      options.load = function (query, callback) {
        if (!query.length) return callback();
        fetch(`${url}?q=${encodeURIComponent(query)}`)
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback());
      };
      options.render = {
        option: (data, escape) => `<div>${escape(data.label)}</div>`,
        item: (data, escape) => `<div>${escape(data.label)}</div>`,
      };
    }

    new TomSelect(el, options);
  });
}

document.addEventListener("turbo:load", initTomSelect);
document.addEventListener("turbo:render", initTomSelect);


function loadTurboData(selectEl) {
  const selectedId = selectEl.value;
  const pathTemplate = selectEl.dataset.turboPath;
  const frame = selectEl.dataset.turboFrame;
  const paramKey = selectEl.dataset.turboParam || "id"; // default fallback

  if (!selectedId || !pathTemplate || !frame) {
    console.warn("Missing required data attributes on select element.");
    return;
  }

  const placeholder = `:${paramKey}`;
  const url = pathTemplate.replace(placeholder, selectedId);

  console.log(`got url: ${url}`)

  Turbo.visit(url, {
    frame: frame,
    action: "replace",
  });
}

window.loadTurboData = loadTurboData;

//////////////////////
// document.addEventListener("turbo:load", function() {
//   $('#choose_event').on("click", function() {
//     var val = $(this).val();
//     $('.event_box').slideUp('fast');
//     if (val != "") {
//       $('#' + val).slideDown('fast');
//     }

//     // update the logo and redirect path on admin nav
//     let data = $(`#${val}`).data();
//     $("#nav_event_redirect").attr("href", data.redirect_path);

//     if (data.image_url != undefined)
//       $("#nav_event_logo").attr("src", data.image_url);
//   });
// });